const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M6.25 11.25a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5a.75.75 0 1 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5zm12.28-3.72a.75.75 0 0 0-1.06-1.06l-12 12a.75.75 0 1 0 1.06 1.06zm-4.78 11.22a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5z"/></svg>';
export {
  a as w
};
